import type { Feature } from '@hotjar/webapp/domains/common/feature/types';
import type { ProductType } from '@hotjar/webapp/domains/common/product/types';
import type { FeatureGroup } from '@hotjar/webapp/domains/revenue/plan/types';
import type {
  knownReferrers,
  planComparisonReferrers,
  trafficRecommendationReferrers,
  multiProductsReferrers,
} from './constants';

export interface PlanComparisonFeatureGateDetails {
  title: string;
  description: string;
  illustration: string;
  sku: ProductType;
  featureName?: Feature;
  minimumFeatureGroup?: FeatureGroup;
  isPlanAgnostic?: boolean;
  modalControls?: {
    titleKey?: string;
    hideFeatureBarPlans?: boolean;
  };
  staticRecommendedFeatureGroup?: FeatureGroup;
}

/**
 * List of feature gates supported by the plan comparison modal
 */
export enum PlanComparisonFeatureGate {
  PageTargeting = 'PageTargeting',
  CustomReactionScales = 'CustomReactionScales',
  RemoveHotjarBranding = 'RemoveHotjarBranding',
  IncomingFeedback = 'IncomingFeedback',
  UserAttributes = 'UserAttributes',
  PercentageTargeting = 'PercentageTargeting',
  Surveys = 'Surveys',
  SurveyCustomization = 'SurveyCustomization',
  SurveyPerformance = 'SurveyPerformance',
  AskEventsApi = 'AskEventsApi',
  ObserveEventsApi = 'ObserveEventsApi',
  FilterClicked = 'FilterClicked',
  FilterError = 'FilterError',
  FilterIncomingFeedback = 'FilterIncomingFeedback',
  FilterNps = 'FilterNps',
  FilterReferrerUrl = 'FilterReferrerUrl',
  FilterRageClicks = 'FilterRageClicks',
  FilterUTurn = 'FilterUTurn',
  FilterUserAttributes = 'FilterUserAttributes',
  FilterUserSegmentsPlus = 'FilterUserSegmentsPlus',
  FilterUserSegmentsBusiness = 'FilterUserSegmentsBusiness',
  FilterUserSegmentsScale = 'FilterUserSegmentsScale',
  AskAdvancedFilters = 'AskAdvancedFilters',
  ObserveAdvancedFilters = 'ObserveAdvancedFilters',
  ObserveBusinessFilters = 'ObserveBusinessFilters',
  GoogleOptimize = 'GoogleOptimize',
  Trends = 'Trends',
  Funnels = 'Funnels',
  AskSlack = 'AskSlack',
  ObserveSlack = 'ObserveSlack',
  AskZapier = 'AskZapier',
  ObserveZapier = 'ObserveZapier',
  AskMsTeams = 'AskMsTeams',
  ObserveMsTeams = 'ObserveMsTeams',
  AskWebhooks = 'AskWebhooks',
  ObserveWebhooks = 'ObserveWebhooks',
  Optimizely = 'Optimizely',
  AskResponseLimit = 'AskResponseLimit',
  SurveyQuestionImages = 'SurveyQuestionImages',
  SurveyAppearanceLogo = 'SurveyAppearanceLogo',
  Unbounce = 'Unbounce',
  ErrorConsole = 'ErrorConsole',
  PublicAPI = 'PublicAPI',
}

export enum TrafficRecommendationFeatureGate {
  Traffic = 'Traffic',
}

export type PlanComparisonReferrer = (typeof planComparisonReferrers)[number];

export type TrafficRecommendationReferrer = (typeof trafficRecommendationReferrers)[number];

// todo: this may be not needed
export type MultiProductsReferrer = (typeof multiProductsReferrers)[number];

export type KnownReferrer = (typeof knownReferrers)[number];
